import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { paymentAPI } from '../services/api';

const PayQR = () => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { payUrl, adviceId } = location.state || {};
  const pollRef   = useRef(null);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    if (!payUrl || !adviceId) { navigate('/request-advice'); return; }

    // Poll every 5 seconds
    pollRef.current = setInterval(async () => {
      try {
        const res = await paymentAPI.getStatus(adviceId);
        if (res.data?.payment_status === 'paid') {
          clearInterval(pollRef.current);
          navigate(`/client/consultations?paid=1&aid=${adviceId}`);
        }
      } catch (_) {}
    }, 5000);

    // Tick counter for UI
    const ticker = setInterval(() => setSeconds(s => s + 1), 1000);

    return () => { clearInterval(pollRef.current); clearInterval(ticker); };
  }, [payUrl, adviceId, navigate]);

  if (!payUrl) return null;

  const qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(payUrl)}`;

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  backgroundColor: '#f7fafc', padding: '2rem' }}>
      <div style={{ backgroundColor: 'white', borderRadius: '20px', padding: '2.5rem 2rem',
                    maxWidth: '380px', width: '100%', textAlign: 'center',
                    boxShadow: '0 8px 40px rgba(0,0,0,0.12)' }}>
        <img src="/payme_logo.svg" alt="Payme" style={{ height: '30px', marginBottom: '1.5rem' }} />

        <p style={{ fontSize: '0.95rem', color: '#4a5568', marginBottom: '1.25rem', fontWeight: '500' }}>
          Payme иловасида QR кодни сканерланг
        </p>

        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1.5rem' }}>
          <img src={qrSrc} alt="QR" width={220} height={220}
               style={{ borderRadius: '12px', border: '1px solid #e2e8f0' }} />
        </div>

        <p style={{ fontSize: '0.82rem', color: '#a0aec0', marginBottom: '1.75rem' }}>
          Тўлов автоматик аниқланади · {seconds}с
        </p>

        <button
          onClick={() => navigate('/request-advice')}
          style={{ width: '100%', padding: '0.75rem', borderRadius: '50px',
                   border: '1.5px solid #e2e8f0', background: 'white',
                   fontSize: '0.9rem', color: '#718096', cursor: 'pointer' }}
        >
          Орқага қайтиш
        </button>
      </div>
    </div>
  );
};

export default PayQR;
